/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DesignSystemIndexRouteImport } from './routes/design-system.index'
import { Route as DesignSystemTokensRouteImport } from './routes/design-system.tokens'
import { Route as DesignSystemIconsRouteImport } from './routes/design-system.icons'
import { Route as DesignSystemComponentsRouteImport } from './routes/design-system.components'
import { Route as DesignSystemBrandRouteImport } from './routes/design-system.brand'
import { Route as AuthInviteCallbackRouteImport } from './routes/auth.invite-callback'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppPlansIndexRouteImport } from './routes/_app.plans.index'
import { Route as AppPlansNewRouteImport } from './routes/_app.plans.new'
import { Route as AppPlansPlanIdRouteImport } from './routes/_app.plans.$planId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemIndexRoute = DesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemTokensRoute = DesignSystemTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemIconsRoute = DesignSystemIconsRouteImport.update({
  id: '/icons',
  path: '/icons',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemComponentsRoute = DesignSystemComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => DesignSystemRoute,
} as any)
const DesignSystemBrandRoute = DesignSystemBrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => DesignSystemRoute,
} as any)
const AuthInviteCallbackRoute = AuthInviteCallbackRouteImport.update({
  id: '/auth/invite-callback',
  path: '/auth/invite-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPlansIndexRoute = AppPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansNewRoute = AppPlansNewRouteImport.update({
  id: '/plans/new',
  path: '/plans/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansPlanIdRoute = AppPlansPlanIdRouteImport.update({
  id: '/plans/$planId',
  path: '/plans/$planId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/design-system': typeof DesignSystemRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invite-callback': typeof AuthInviteCallbackRoute
  '/design-system/brand': typeof DesignSystemBrandRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/icons': typeof DesignSystemIconsRoute
  '/design-system/tokens': typeof DesignSystemTokensRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/plans/$planId': typeof AppPlansPlanIdRoute
  '/plans/new': typeof AppPlansNewRoute
  '/plans/': typeof AppPlansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invite-callback': typeof AuthInviteCallbackRoute
  '/design-system/brand': typeof DesignSystemBrandRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/icons': typeof DesignSystemIconsRoute
  '/design-system/tokens': typeof DesignSystemTokensRoute
  '/design-system': typeof DesignSystemIndexRoute
  '/plans/$planId': typeof AppPlansPlanIdRoute
  '/plans/new': typeof AppPlansNewRoute
  '/plans': typeof AppPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/design-system': typeof DesignSystemRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invite-callback': typeof AuthInviteCallbackRoute
  '/design-system/brand': typeof DesignSystemBrandRoute
  '/design-system/components': typeof DesignSystemComponentsRoute
  '/design-system/icons': typeof DesignSystemIconsRoute
  '/design-system/tokens': typeof DesignSystemTokensRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/_app/plans/$planId': typeof AppPlansPlanIdRoute
  '/_app/plans/new': typeof AppPlansNewRoute
  '/_app/plans/': typeof AppPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/design-system'
    | '/sign-in'
    | '/auth/callback'
    | '/auth/invite-callback'
    | '/design-system/brand'
    | '/design-system/components'
    | '/design-system/icons'
    | '/design-system/tokens'
    | '/design-system/'
    | '/plans/$planId'
    | '/plans/new'
    | '/plans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/auth/callback'
    | '/auth/invite-callback'
    | '/design-system/brand'
    | '/design-system/components'
    | '/design-system/icons'
    | '/design-system/tokens'
    | '/design-system'
    | '/plans/$planId'
    | '/plans/new'
    | '/plans'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/design-system'
    | '/sign-in'
    | '/auth/callback'
    | '/auth/invite-callback'
    | '/design-system/brand'
    | '/design-system/components'
    | '/design-system/icons'
    | '/design-system/tokens'
    | '/design-system/'
    | '/_app/plans/$planId'
    | '/_app/plans/new'
    | '/_app/plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DesignSystemRoute: typeof DesignSystemRouteWithChildren
  SignInRoute: typeof SignInRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthInviteCallbackRoute: typeof AuthInviteCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system/': {
      id: '/design-system/'
      path: '/'
      fullPath: '/design-system/'
      preLoaderRoute: typeof DesignSystemIndexRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/tokens': {
      id: '/design-system/tokens'
      path: '/tokens'
      fullPath: '/design-system/tokens'
      preLoaderRoute: typeof DesignSystemTokensRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/icons': {
      id: '/design-system/icons'
      path: '/icons'
      fullPath: '/design-system/icons'
      preLoaderRoute: typeof DesignSystemIconsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/components': {
      id: '/design-system/components'
      path: '/components'
      fullPath: '/design-system/components'
      preLoaderRoute: typeof DesignSystemComponentsRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/brand': {
      id: '/design-system/brand'
      path: '/brand'
      fullPath: '/design-system/brand'
      preLoaderRoute: typeof DesignSystemBrandRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/auth/invite-callback': {
      id: '/auth/invite-callback'
      path: '/auth/invite-callback'
      fullPath: '/auth/invite-callback'
      preLoaderRoute: typeof AuthInviteCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/plans/': {
      id: '/_app/plans/'
      path: '/plans'
      fullPath: '/plans/'
      preLoaderRoute: typeof AppPlansIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/new': {
      id: '/_app/plans/new'
      path: '/plans/new'
      fullPath: '/plans/new'
      preLoaderRoute: typeof AppPlansNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/$planId': {
      id: '/_app/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/plans/$planId'
      preLoaderRoute: typeof AppPlansPlanIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppPlansPlanIdRoute: typeof AppPlansPlanIdRoute
  AppPlansNewRoute: typeof AppPlansNewRoute
  AppPlansIndexRoute: typeof AppPlansIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPlansPlanIdRoute: AppPlansPlanIdRoute,
  AppPlansNewRoute: AppPlansNewRoute,
  AppPlansIndexRoute: AppPlansIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface DesignSystemRouteChildren {
  DesignSystemBrandRoute: typeof DesignSystemBrandRoute
  DesignSystemComponentsRoute: typeof DesignSystemComponentsRoute
  DesignSystemIconsRoute: typeof DesignSystemIconsRoute
  DesignSystemTokensRoute: typeof DesignSystemTokensRoute
  DesignSystemIndexRoute: typeof DesignSystemIndexRoute
}

const DesignSystemRouteChildren: DesignSystemRouteChildren = {
  DesignSystemBrandRoute: DesignSystemBrandRoute,
  DesignSystemComponentsRoute: DesignSystemComponentsRoute,
  DesignSystemIconsRoute: DesignSystemIconsRoute,
  DesignSystemTokensRoute: DesignSystemTokensRoute,
  DesignSystemIndexRoute: DesignSystemIndexRoute,
}

const DesignSystemRouteWithChildren = DesignSystemRoute._addFileChildren(
  DesignSystemRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DesignSystemRoute: DesignSystemRouteWithChildren,
  SignInRoute: SignInRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthInviteCallbackRoute: AuthInviteCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
